import { render } from "./CabinetMinisterList.vue?vue&type=template&id=002dd054&scoped=true&ts=true"
import script from "./CabinetMinisterList.ts?vue&type=script&lang=ts"
export * from "./CabinetMinisterList.ts?vue&type=script&lang=ts"

import "./CabinetMinisterList.scss?vue&type=style&index=0&id=002dd054&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002dd054"]])

export default __exports__